export default {
  title: 'SEARCH RESULTS',
  totalResult: {
    label: 'RESULTS',
  },
  tabs: {
    product: 'Products',
    provider: 'Producers',
    blogs: 'Blogs',
  }
};
